import api from './api';

const baseUrl = '/print';

export default {
  async getTcmConsultationPrescriptionById(id) {
    return api.get(`${baseUrl}/tcm-consultation/prescription/${id}`);
  },
};
